import React, { useState } from 'react'
import MyTextField from '../../../UI/form/MyTextField'
import TextFieldUniversal from '../../../validate/form/text/TextFieldUniversal'

const LoginFormUsername = ({ required, setValidate, setValueForm, forciblyValue }) => {

	const [value, setValue] = useState('')

  return (
    // <MyTextField 
    //     label={'Телефон/email'}
    //     placeholder={'Вкажіть номер телефону або email'}
    // />
	<TextFieldUniversal
        value={value}
        setValue={e => {
            setValueForm(e)
            setValue(e)
        }}
        setValidate={setValidate}
        label={'E-mail'} 
        placeholder={'Вкажіть email'}
        validates={{
            isEmpty: true
        }}
        // forciblyValue={forciblyValue}
        required={true}
    />
  )
}

export default LoginFormUsername